import React from "react";
import { Link, NavLink } from "react-router-dom";
import { OverflowMenu } from "@icoach/components";
import { billingStatusColorMap } from "@icoach/accountBook/staticData";
import { formatCurrencyFn } from "@util/utils";
import { parseDate } from "@util/moment";
import { Chip, Typography } from "@curves/ui-base";
import { ACCOUNT_BOOK_BULK_DEBIT_BILLING_DETAIL_URL } from "@icoach/router/routerPath";

export const getBillingRowsLabel = () => [
	{
		cellKey: "sendDate",
		headerLabel: "送件日期",
		formatCell: cellValue => {
			const _parseDate = (date, format) => {
				return parseDate(date, format, false);
			};
			return (
				<React.Fragment>
					<Typography className="mb-0">{_parseDate(cellValue, "YYYY/MM/DD")}</Typography>
					<Typography className="mb-0 font-color-3">{_parseDate(cellValue, "HH:mm")}</Typography>
				</React.Fragment>
			);
		},
	},
	{
		cellKey: "billingItem",
		headerLabel: "扣款方式",
		align: "center",
		formatCell: (cellValue, { billingID }) => {
			return (
				<Link className={"text-decoration-underline"} to={ACCOUNT_BOOK_BULK_DEBIT_BILLING_DETAIL_URL(billingID)}>
					{cellValue}
				</Link>
			);
		},
	},
	{
		cellKey: "billingStatusText",
		headerLabel: "狀態",
		align: "center",
		formatCell: (cellValue, { billingStatusColor = 0 }) => {
			return <Chip label={cellValue} color={billingStatusColorMap.get(billingStatusColor)} />;
		},
	},
	{
		cellKey: "totalQuantity",
		headerLabel: "總筆數",
		align: "center",
	},
	{
		cellKey: "successQuantity",
		headerLabel: "成功筆數",
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="success" />;
		},
	},
	{
		cellKey: "failureQuantity",
		headerLabel: "失敗筆數",
		align: "center",
		formatCell: cellValue => {
			return <Chip label={cellValue} color="error" />;
		},
	},
	{
		cellKey: "employeeDisplayName",
		headerLabel: "擔當",
		align: "center",
	},
	{
		cellKey: "paymentPrice",
		headerLabel: "扣款金額",
		align: "right",
		formatCell: cellValue => {
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "returnPrice",
		headerLabel: "退款金額",
		align: "right",
		formatCell: cellValue => {
			console.log("returnPrice");
			return formatCurrencyFn(cellValue);
		},
	},
	{
		cellKey: "more",
		headerLabel: "",
		width: 6.8,
		formatCell: (cellValue, { billingID, canCancel, canAchAction }, { dialogRef, refresh, onClickDownloadACH, onDeleteBilling }) => {
			let menuData = [
				{
					text: "查看",
					component: NavLink,
					to: ACCOUNT_BOOK_BULK_DEBIT_BILLING_DETAIL_URL(billingID),
				},
			];

			if (canAchAction) {
				menuData = [
					...menuData,
					{
						text: "下載扣款名單",
						onClick: () => {
							if (typeof onClickDownloadACH === "function") onClickDownloadACH(billingID);
						},
					},
					{
						text: "回填扣款紀錄",
						onClick: () => {
							dialogRef.current && dialogRef.current.openImportAchDialog({ billingID }, refresh);
						},
					},
				];
			}

			if (canCancel) {
				menuData = [
					...menuData,
					{
						text: "取消批次扣款",
						onClick: () => {
							if (typeof onDeleteBilling === "function") onDeleteBilling(billingID);
						},
					},
				];
			}

			return <OverflowMenu menuData={menuData} textAlign={"center"} />;
		},
	},
];
